const SelfPublishingType = {
  NONE: 'None',
  DISTRIBUTION: 'Amazon distribution',
  DISTRIBUTION_PROMOTION: 'Amazon distribution and promotion',
  MULTI_DISTRIBUTION_PROMOTION: 'Multiplatform distribution and promotion',
};

module.exports = SelfPublishingType;
